var moduleMap = {
	"./handlers": function() {
		return Promise.all([__webpack_require__.e("vendors"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("src_mocks_handlers_autoConfigRuleHandlers_ts-src_mocks_handlers_awsStorageRulesHandlers_ts-sr-081eca"), __webpack_require__.e("src_backupset_api_paths_ts-src_common_autoConfig_api_paths_ts-src_common_autoConfig_constants-9c4856"), __webpack_require__.e("src_mocks_handlers_ts")]).then(function() { return function() { return (__webpack_require__(10649)); }; });
	},
	"./mountComponent": function() {
		return Promise.all([__webpack_require__.e("vendors"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("src_backupset_api_paths_ts-src_common_autoConfig_api_paths_ts-src_common_autoConfig_constants-9c4856"), __webpack_require__.e("src_AppContainer_tsx-node_modules_moment_locale_sync_recursive_-webpack_sharing_consume_defau-0c2407"), __webpack_require__.e("src_mount_tsx")]).then(function() { return function() { return (__webpack_require__(68942)); }; });
	},
	"./mfeConfig": function() {
		return __webpack_require__.e("src_mfeconfig_ts").then(function() { return function() { return (__webpack_require__(56382)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});